import React from "react";
import moment from "moment";
//Import from project
import { currencyFormat, currencyFormatRiel } from "../../Function/DynamicFn";

export default function ExportDisbursement({ tableData, tableRef }) {
  return (
    <div style={{ width: "100%", display: "none" }} ref={tableRef}>
      <table className="table-cash">
        <thead className="thead-cash">
          <tr>
            <th className="title-table">កាលបរិច្ឆេទ</th>
            <th className="title-table">លេខរៀង</th>
            <th className="title-table">លេខវិក័យបត្រ</th>
            <th className="title-table">អ្នកផ្គត់ផ្គង់</th>
            <th className="title-table">ប្រភេទទំនិញ</th>
            <th className="title-table">ចំនួន</th>
            <th className="title-table">អត្រាប្តូរប្រាក់</th>
            <th className="title-table">សរុបដុល្លា</th>
            <th className="title-table">រៀល</th>
            <th className="title-table">ដុល្លា</th>
            <th className="title-table">ប្រភេទចំណាយ</th>
          </tr>
        </thead>
        <tbody className="tbody-cash">
          {tableData?.map((row, index) => (
            <tr key={index}>
              <td className="title-table">
                {moment(row?.date)?.format("DD-MMM-yyyy")}
              </td>
              <td className="title-table">{row?.disbursementNumber}</td>
              <td className="title-table">{row?.InvoiceNo}</td>
              <td className="title-table">{row?.supplier}</td>
              <td className="title-table">{row?.description}</td>
              <td className="title-table">{row?.qty}</td>
              <td
                className="title-table"
                align="right"
                style={{ color: "purple" }}
              >
                {currencyFormatRiel(parseFloat(row?.exchangeRate))} ៛
              </td>
              <td
                className="title-table"
                align="right"
                style={{ color: "red" }}
              >
                $ {currencyFormat(row?.totalPriceAsUSD)}
              </td>
              <td
                className="title-table"
                align="right"
                style={{ color: "blue" }}
              >
                {currencyFormatRiel(row?.priceKHR)} ៛
              </td>
              <td
                className="title-table"
                align="right"
                style={{ color: "blue" }}
              >
                $ {currencyFormat(row?.priceUSD)}
              </td>
              <td className="title-table">{row?.accountName}</td>
            </tr>
          ))}
          {/* <tr>
            <td className="title-table-stat tb-txt-redb" colSpan={8}>
              សរុបទឹកប្រាក់(Total)
            </td>
            <td className="title-table-stat tb-txt-redb">
              {formatNumber(totalPriceKHR)} ៛
            </td>
            <td
              className="title-table-stat tb-txt-redb"
              style={{
                color: "red",
                padding: "8px",
                fontWeight: "bold",
              }}
            >
              ${formatNumber(totalPriceUSD)}
            </td>
          </tr> */}
        </tbody>
      </table>
    </div>
  );
}
